export enum GENDER_TYPE {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}
